/* eslint-disable @typescript-eslint/no-explicit-any */
import {compressFile} from '../../common/utils/compression';
import {
  countPersonsInAgeRanges,
  defaultAgeRangeVoyage,
} from '../../common/utils/functions';
import {ApiResponse} from '../../data/types/interface/api';
import {itemI} from '../../presentations/components/Inputs/DatePickerModal/MultiDatePicker';
import {VoyageBDL} from '../bdl/voyage';

export interface souscriptionAssureBodyDTO {
  first_name: string;
  last_name: string;
  title: 'M' | 'Mr' | 'Mme' | 'Mlle';
  email: string;
  passport_number: string;
  phone_number: string;
  dateNaissance?: string;
  datePasseport?: string;
  lieuNaissance?: string;
  passport_file?: File;
}

// Format des dates YYYY-MM-DD
export interface IPostDevis {
  idCategory: number;
  idDestination: number;
  dateDebut: Date;
  dateFin: Date;
  dateNaissance: string;
  motif?: string;
  listNaissance: Array<itemI>;
}

export interface ISaveDevis {
  id?: string;
  idDestination: number;
  dateDebut: Date;
  dateFin: Date;
  listNaissance: Array<string>;
  dateNaissance: string;
  enfant: string;
  adult: string;
  senior: string;
  motif?: string;
  idCategory: number;
}
interface ISouscriptionContrat {
  quoteCode: string;
  agence: string;
  montant: string;
  assure: Array<souscriptionAssureBodyDTO>;
}
export interface IModificationContrat {
  policyId: string;
  message: string;
  destination: string;
  policyNumber: string;
  dateFin: Date;
  dateDebut: Date;
  assure: Array<{
    id: string;
    axaId: string;
    nom: string;
    prenom: string;
    email: string;
    phoneNumber: string;
    passeportNumber: string;
    passeportFile: string | File[];
    newImage: boolean;
    lastPasseportFile: string;
  }>;
}

export const VoyageServices = () => {
  const {
    postDevis,
    saveDevis,
    listDevis,
    removeDevis,
    listDestinations,
    listCategories,
    souscrireContrat,
    modificationContrat,
    resiliationContrat,
    detailContrat,
    getPolicyNumberByQuoteCode,
    getStatusPayment,
    uploadPassportPhoto,
  } = VoyageBDL();

  return {
    postDevis: async (data: IPostDevis) => {
      const categorizedAge = countPersonsInAgeRanges(
        data.listNaissance,
        defaultAgeRangeVoyage,
        'value',
      );

      const res: ApiResponse = await postDevis({
        ...data,
        enfant: categorizedAge.childrens,
        senior: categorizedAge.seniors,
        adult: categorizedAge.adults,
      });
      if (!res.isError && Array.isArray(res.data) && res.data.length) {
        return {
          ...res,
          data: res.data.map((element: any) => {
            return {
              ...element,
              montant: Math.ceil(element.montant).toString(),
            };
          }),
        };
      } else {
        return res;
      }
    },
    saveDevis: async (data: ISaveDevis) => {
      return await saveDevis(data);
    },
    removeDevis: async (id: string) => {
      return await removeDevis(id);
    },
    souscrireContrat: async (data: ISouscriptionContrat) => {
      try {
        for (const currentAssure of data.assure) {
          const compressedFile = await compressFile(
            currentAssure?.passport_file as File,
          );
          console.log(compressedFile);

          const uploadedFile = await uploadPassportPhoto(compressedFile);

          if (uploadedFile.data) {
            currentAssure.passport_file = uploadedFile.data.data.fullPath;
          } else {
            console.log(uploadedFile);

            throw new Error(
              uploadedFile.message ||
                `Erreur lors de l'upload de la photo de ${currentAssure.last_name} ${currentAssure.first_name}`,
            );
          }
        }
        return await souscrireContrat(data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    resiliationContrat: async (data: {policyId: string; message: string}) => {
      return await resiliationContrat(data);
    },
    modificationContrat: async (data: IModificationContrat) => {
      console.log('data putModification', data);
      for (const currentAssure of data.assure) {
        if (currentAssure.newImage) {
          try {
            const uploadedFile = await uploadPassportPhoto(
              currentAssure?.passeportFile[0] as File,
            );

            currentAssure.passeportFile = uploadedFile.data.data.fullPath;
            console.log(currentAssure.passeportFile);
          } catch (error) {
            return Promise.reject(error);
          }
        } else {
          currentAssure.passeportFile = currentAssure.lastPasseportFile;
        }
      }
      return await modificationContrat(data);
    },
    listDevis: async () => {
      return await listDevis();
    },
    listDestinations: async (category: string) => {
      return await listDestinations(category);
    },
    listCategories: async () => {
      return await listCategories();
    },
    detailContrat: async (numPolice: string) => {
      return await detailContrat(numPolice);
    },
    getPolicyNumberByQuoteCode: async (quoteCode: string) => {
      return await getPolicyNumberByQuoteCode(quoteCode);
    },
    getStatusPayment: async () => {
      return await getStatusPayment();
    },
    uploadPassportPhoto: async (file: File) => {
      return uploadPassportPhoto(file);
    },
  };
};
